<template>
  <div id="page-user-view">
    <Charger
      :isPromptActive="addNewPrompt"
      @closePrompt="toggleDataPrompt"
      :charger="charger"
      :refreshContent="general"
    />
    <transferred-folder
      :isPromptActive="showFolder"
      @closeFolder="toggleFolderPrompt"
      :folders="folders"
      :getRequests_detail_information="getRequests_detail_information"
    />
    <close
      :isPromptActive="closePrompt"
      @closePrompt="toggleClosePrompt"
      :info="info"
      :callback="end_request"
      :callbackNoFeedBack="endRequestNoFeedBack"
    />
    <vs-button
      class="mb-2 shadow-lg"
      type="border"
      @click="$router.go(-1)"
      size="small"
      >Retour
    </vs-button>
    <div class="vx-row">
      <div class="vx-col lg:w-2/3 w-full">
        <vx-card
          title="Détails de la demande"
          refresh-content-action
          @refresh="closeCardAnimation"
        >
          <div slot="no-body" class="p-6">
            <div class="tabs-container">
              <vs-tabs
                v-model="activeTab"
                class="tab-action-btn-fill-conatiner"
              >
                <vs-tab
                  label="Informations"
                  icon-pack="feather"
                  icon="icon-info"
                >
                  <div class="tab-text" v-if="information.customer">
                    <div class="vx-row mb-4">
                      <div class="vx-col" id="avatar-col">
                        <div class="img-container mb-4">
                          <!-- ||||||||||-- {{information.customer.logo}} --|||||||||| -->
                          <img
                            style="max-width: 180px; max-height: 180px"
                            v-if="information.customer.logo"
                            :src="information.customer.logo"
                            class="rounded w-full shadow-drop"
                          />
                          <!-- :src="information.customer.logo" -->

                          <img
                            v-if="!information.customer.logo"
                            src="@/assets/images/ccmt_mtn_logo.jpeg"
                            class="rounded w-full shadow-drop"
                          />
                          <!--<img
                            v-if="!information.customer.logo"
                            src="@/assets/images/ccmt_togocel_logo.jpg"
                            class="rounded w-full shadow-drop"
                          />-->
                        </div>
                      </div>

                      <div class="vx-col flex-1">
                        <div class="flex mb-3">
                          <div class="flex-1">
                            <span>Client</span>
                            <h5
                              class="text-primary cursor-pointer"
                              @click="clientActive = true"
                            >
                              {{ information.customer.social_reason }}
                            </h5>
                            <vs-popup
                              class="holamundo"
                              title="Détails du client"
                              :active.sync="clientActive"
                            >
                              <div class="vx-row">
                                <div class="vx-col">
                                  <img
                                    src="@/assets/images/eba-client-2.png"
                                    class="rounded w-full shadow-drop"
                                  />
                                </div>
                                <div class="vx-col flex-1">
                                  <div class="mb-2">
                                    <span>Raison sociale</span>
                                    <h5>
                                      {{ information.customer.social_reason }}
                                    </h5>
                                  </div>
                                  <div class="flex justify-between mb-2">
                                    <div>
                                      <span>Catégorie</span>
                                      <h5>
                                        {{ information.customer.segment }}
                                      </h5>
                                    </div>
                                    <div>
                                      <span>Secteur d'activité</span>
                                      <h5>
                                        {{ information.customer.activity_area }}
                                      </h5>
                                    </div>
                                    <div>
                                      <span>Régime de taxation</span>
                                      <h5>{{ information.customer.tax }}</h5>
                                    </div>
                                  </div>
                                  <div class="mb-2">
                                    <span>Email</span>
                                    <h5>
                                      <a :href="information.customer.email">{{
                                        information.customer.email
                                      }}</a>
                                    </h5>
                                  </div>
                                  <div class="flex mb-2">
                                    <div class="mr-4">
                                      <span>Téléphone</span>
                                      <h5>{{ information.customer.phone }}</h5>
                                    </div>
                                    <div>
                                      <span>Fax</span>
                                      <h5>{{ information.customer.fax }}</h5>
                                    </div>
                                  </div>
                                  <div class="mb-2">
                                    <span class="font-semibold">Adresse</span>
                                    <p>{{ information.customer.address }}</p>
                                  </div>
                                </div>
                              </div>
                            </vs-popup>
                          </div>
                          <div class="flex-1">
                            <span>Contrat</span>
                            <h5
                              class="text-primary cursor-pointer"
                              @click="contractActive = true"
                            >
                              {{ information.contract }}
                            </h5>
                            <vs-popup
                              class="holamundo"
                              title="Détails du contract"
                              :active.sync="contractActive"
                            >
                              <h4>CONTRAT</h4>
                            </vs-popup>
                          </div>
                          <div class="flex-1">
                            <span>Traitée par</span>
                            <h5 class="">
                              {{ information.treat_by }}
                            </h5>
                          </div>
                        </div>
                        <div class="mb-3">
                          <span>Type de requête</span>
                          <h5>
                            {{ information.type }} - {{ information.subtype }}
                          </h5>
                        </div>
                        <div class="flex items-center mb-3">
                          <vs-chip color="primary">
                            <vs-avatar icon="cached" />
                            {{ information.status }}
                          </vs-chip>
                          <vs-chip
                            :color="getPriorityColor(information.priority)"
                          >
                            <vs-avatar icon="warning" />
                            {{ information.priority }}
                          </vs-chip>
                          <!-- <span>Créé le {{convert_date(information.created_at).dateTime}}</span> -->
                          <span
                            >Créé le
                            {{ convert_date(information.created_at) }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-divider />
                        <h4 class="mb-3">{{ information.title }}</h4>
                        <div>
                          <p v-html="information.content"></p>
                        </div>
                        <div v-if="information.comment">
                          <vs-divider />
                          <strong>Commentaire du client</strong>
                          <p>{{ information.comment }}</p>
                        </div>
                        <div class="vx-row" v-if="information.files.length">
                          <div
                            class="
                              vx-col
                              w-full
                              border-b border-l-0 border-r-0 border-t-0
                              d-theme-border-grey-light
                              border-solid
                              mb-6
                              flex
                            "
                          >
                            <feather-icon icon="PaperclipIcon" class="mr-2" />
                            <span class="block py-4">FICHIERS JOINTS</span>
                          </div>
                          <div class="flex">
                            <VuePerfectScrollbar
                              ref="chatLogPS"
                              class="scroll-area pt-6 px-6"
                              :settings="settings"
                              key="eeee"
                            >
                              <div
                                class="mail__attachment"
                                v-for="(attachment, index) in information.files"
                                :key="index"
                                @click.stop="openinnewwindows(attachment.url)"
                              >
                                <vs-chip
                                  color="grey"
                                  class="ml-2 mr-3 cursor-pointer"
                                >
                                  <vs-avatar icon="cloud_download" />
                                  {{ attachment.filename }}
                                </vs-chip>
                              </div>
                            </VuePerfectScrollbar>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab
                  label="Historique"
                  icon-pack="feather"
                  icon="icon-clock"
                >
                  <vx-timeline :data="history"></vx-timeline>
                </vs-tab>
                <vs-tab
                  v-if="$store.state.is_chargerClientele()"
                  label="Mes tâches"
                  icon-pack="feather"
                  icon="icon-check-square"
                >
                  <h5>Mes tâches</h5>
                  <Todo />
                </vs-tab>
                <vs-tab
                  v-if="makeAccessApprobation"
                  label="Chaine d'approbation"
                  icon-pack="feather"
                  icon="icon-check-circle"
                >
                  <approval :base="this" :data="approvalDatas" />
                </vs-tab>
                <vs-tab
                  :label="commentTabTitle"
                  icon-pack="feather"
                  icon="icon-message-square"
                >
                  <VuePerfectScrollbar class="scroll-area" :settings="settings">
                    <comments :comments="comments" />
                  </VuePerfectScrollbar>
                </vs-tab>
              </vs-tabs>
            </div>
            <vs-divider />
            <div v-if="appreciation == 4 || appreciation == 9">
              <vs-textarea
                :style="error.raison ? 'border-color: #EA5455 !important;' : ''"
                v-model="raison"
                label="Raison de l'insatisfaction"
              />
              <span v-if="error.raison" style="color: #ea5455">{{
                error.raison ? error.raison[0] : ""
              }}</span>
            </div>
            <div
              class="
                flex flex-wrap
                justify-end
                pb-3
                border-t border-l-0 border-r-0 border-b-0
                d-theme-border-grey-light
                border-solid
              "
            >
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  ($store.state.is_client() || $store.state.is_mandataire()) &&
                  information.date_end_treat !== null &&
                  information.date_begin_treat !== null &&
                  checkReOpenCustomer()
                "
                @click="requests_reopen()"
              >
                Réouvrir
              </vs-button>
              <vs-select
                @change="changeRequestState()"
                v-if="
                  ($store.state.is_client() || $store.state.is_mandataire()) &&
                  information.date_end_treat !== null &&
                  information.date_begin_treat !== null &&
                  Number(information.status_index) === 2
                "
                placeholder="Appréciation"
                class="mt-4 mr-2"
                autocomplete
                v-model="appreciation"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in appreciation_options"
                />
              </vs-select>
              <vs-button
                style="height: 38px !important"
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  ($store.state.is_client() || $store.state.is_mandataire()) &&
                  information.date_end_treat !== null &&
                  information.date_begin_treat !== null &&
                  Number(information.status_index) === 2
                "
                @click="satisfied_request()"
              >
                Cloturée
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  $store.state.is_chargerClientele() &&
                  information.date_begin_treat === null &&
                  demarrerLeTraitement
                "
                @click="start_request()"
                >Démarrer le traitement
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  $store.state.is_chargerClientele() &&
                  information.date_end_treat === null &&
                  information.date_begin_treat !== null &&
                  information.status_index !== '11' &&
                  information.treat_user_id === $store.state.AppActiveUser.id
                "
                @click="showSendModal()"
                >Clôturer
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  $store.state.is_dispatcher() &&
                  information.date_end_treat === null
                "
                @click="assignShow()"
                >Assigner la requête
              </vs-button>
              <vs-button
                @click="addToFolder()"
                v-if="
                  profile_id != '4' &&
                  profile_id != '5' &&
                  profile_id != '7' &&
                  information.date_begin_treat === null &&
                  information.folder === null
                "
                class="mt-4 mr-2 shadow-lg"
                type="border"
              >
                Transferer dans un dossier
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  $store.state.is_chargerClientele() &&
                  information.date_end_treat === null &&
                  information.date_begin_treat !== null &&
                  information.status_index !== '10' &&
                  information.status_index !== '11' &&
                  information.treat_user_id === $store.state.AppActiveUser.id
                "
                @click="putInStandBy()"
                >Suspendre traitement
              </vs-button>

              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  $store.state.is_chargerClientele() &&
                  information.date_end_treat === null &&
                  information.date_begin_treat !== null &&
                  information.status_index == '10' &&
                  information.status_index !== '11' &&
                  information.treat_user_id === $store.state.AppActiveUser.id
                "
                @click="stopStandBy()"
                >Reprendre traitement
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                @click="
                  (show_comment_zone = !show_comment_zone),
                    (files = []),
                    (file_names = []),
                    (comment.message = '')
                "
                >Commenter
              </vs-button>
              <vs-button
                v-if="
                  !['2', '3', '4', '7', '8', '9', '11'].includes(
                    information.status_index
                  )
                "
                class="mt-4 mr-2 shadow-lg"
                type="border"
                @click="cancelRequest()"
                >Annuler ticket
              </vs-button>
            </div>
            <div v-if="show_comment_zone == true" class="comment_zone">
              <vs-textarea
                rows="4"
                v-model="comment.message"
                placeholder="Votre commentaire"
                class="mr-3 w-full"
                name="item-name"
              >
              </vs-textarea>
              <vs-button
                @click="$refs.updateCommentImgInput.click()"
                type="filled"
                size="small"
                >Ajouter un fichier</vs-button
              >
              <input
                type="file"
                class="hidden"
                ref="updateCommentImgInput"
                @change="incCommentFile"
              />
              <vs-row>
                <div v-for="(img, index) in files" :key="index">
                  <div class="modify-img flex justify-between mt-5">
                    <div class="mail__attachment">
                      <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
                        <vs-avatar icon="cloud_download" />
                        {{ file_names[index] }}
                      </vs-chip>
                    </div>
                    <vs-button
                      @click="devCommentFile(file_names[index])"
                      type="border"
                      color="danger"
                      size="small"
                      >Supprimer</vs-button
                    >
                  </div>
                </div>
              </vs-row>
              <vs-button
                size="small"
                :disabled="files.length == 0 && comment.message == ''"
                class="mt-4 mr-2 shadow-lg"
                type="border"
                @click="sendComment()"
                >Envoyer
              </vs-button>
              <vs-button
                size="small"
                class="mt-4 ml-1 shadow-lg"
                type="filled"
                @click="
                  (show_comment_zone = false),
                    (files = []),
                    (file_names = []),
                    (comment.message = '')
                "
                >Annuler
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
      <div v-if="ccmt_ommentaires" class="vx-col lg:w-1/3 w-full">
        <vx-card
          title="Discussion"
          class="overflow-hidden"
          collapse-action
          refresh-content-action
          @refresh="closeCardAnimationDemo"
        >
          <template slot="no-body">
            <div class="chat-card-log bg-grey-light">
              <VuePerfectScrollbar
                ref="chatLogPS"
                class="scroll-area pt-6 px-6"
                :settings="settings"
                :key="$vs.rtl"
              >
                <ul ref="chatLog">
                  <li
                    class="flex items-start"
                    :class="{
                      'flex-row-reverse': verifyUser(msg.user_id),
                      'mt-4': index,
                    }"
                    v-for="(msg, index) in chatLog"
                    :key="index"
                  >
                    <div
                      class="
                        msg
                        relative
                        bg-white
                        shadow-md
                        py-3
                        px-4
                        mb-2
                        rounded-lg
                        max-w-md
                      "
                      :class="{
                        'chat-sent-msg bg-primary-gradient text-white':
                          verifyUser(msg.user_id),
                        'border border-solid d-theme-border-grey-light':
                          !verifyUser(msg.user_id),
                      }"
                    >
                      <div class="mb-2">
                        <h6 class="mb-2">
                          {{ msg.name ? msg.name : "Vous" }}
                          <span class="text-grey" v-if="msg.senderCompany">
                            - {{ msg.senderCompany }}</span
                          >
                        </h6>
                        <span class="text-sm flex"
                          ><feather-icon
                            icon="ClockIcon"
                            svgClasses="w-4 h-4 hover:text-primary stroke-current"
                            class="mr-1"
                          />
                          {{ msg.created_at }}</span
                        >
                      </div>
                      <div v-html="msg.content"></div>

                      <div
                        v-if="msg.files"
                        class="mail__attachment"
                        @click.stop="
                          downloadFile(msg.files.name, msg.files.link)
                        "
                      >
                        <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
                          <vs-avatar icon="cloud_download" />
                          {{ truncateFileName(msg.files.name) }}
                        </vs-chip>
                      </div>
                    </div>
                  </li>
                </ul>
              </VuePerfectScrollbar>
            </div>
            <div class="flex bg-white p-6 chat-input-container">
              <!-- <vs-textarea
                      class="mr-3 w-full"
                      v-model="chatMsgInput"
                      height="40px"
                      placeholder="Votre commentaire"
              /> -->
              <div>
                <vs-textarea
                  rows="2"
                  v-if="
                    profile_id !== 1 && profile_id !== 6 && profile_id !== 7
                  "
                  v-model="chatMsgInput"
                  placeholder="Votre message"
                  class="mr-3 w-full"
                  name="item-name"
                >
                </vs-textarea>
                <span style="font-size: 12px; color: #ea5455">{{
                  error.files ? error.files[0] : ""
                }}</span>
              </div>
              <vs-button
                class="ml-1"
                style="margin-top: 20px"
                v-if="
                  profile_id != '1' && profile_id != '6' && profile_id != '7'
                "
                icon-pack="feather"
                icon="icon-send"
                @click="messages_create(chatMsgInput)"
              />
              <vs-button
                class="ml-1"
                style="margin-top: 20px"
                v-if="
                  profile_id != '1' && profile_id != '6' && profile_id != '7'
                "
                icon-pack="feather"
                icon="icon-file"
                @click="$refs.updateImgInput.click()"
              />
              <input
                type="file"
                class="hidden"
                ref="updateImgInput"
                @change="sendFile"
                accept="image/*,application/pdf,application/vnd.ms-excel"
              />
            </div>
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import TransferredFolder from "./transferredFolder";

var base_self;
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VxTimeline from "@/components/timeline/VxTimeline.vue";
import Todo from "./components/Todo";
import Approval from "./components/Approval";
import Charger from "./charger";
import Close from "./Close.vue";
import moment from "moment";
import Comments from "./components/comments.vue";

export default {
  components: {
    TransferredFolder,
    Approval,
    Todo,
    VuePerfectScrollbar,
    VxTimeline,
    Charger,
    Close,
    Comments,
  },
  watch: {
    "$route.params.id": function () {
      base_self.general();
    },
  },
  mounted() {
    // this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
    base_self.profile_id = window.GETCCMT.$store.state.AppActiveUser.profile_id;
    base_self.user_id = window.GETCCMT.$store.state.AppActiveUser.id;
    base_self.general();
    base_self.messages_request(base_self.$route.params.id);
    window.chatNotification = setInterval(() => {
      base_self.messages_request(base_self.$route.params.id);
    }, 5000);
  },
  data() {
    return {
      closePrompt: false,
      folders: [],
      showFolder: false,
      addNewPrompt: false,
      charger: [],
      raison: "",
      info: {},
      appreciation_options: [
        { id: "3", name: "Satisfait" },
        { id: "8", name: "Moyennement satisfait" },
        { id: "7", name: "Très satisfait" },
        { id: "4", name: "Pas satisfait" },
        { id: "9", name: "Pas du tout satisfait" },
      ],
      profile_id: null,
      appreciation: "3",
      error: [],
      user_id: null,
      test: false,
      approvalDatas: [],
      ccmt_ommentaires: true, // this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
      information: {},
      history: [],
      tasks: [],
      chatLog: [],
      isPaused: false,
      activeTab: 0,
      clientActive: false,
      contractActive: false,
      chatMsgInput: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      timelineData: [],
      show_comment_zone: false,
      comment: {
        message: "",
      },
      comments: [],
      files: [],
      file_names: [],
      comment_tab_title: "Commentaires",
    };
  },
  beforeRouteLeave(to, from, next) {
    if (window.chatNotification) {
      clearTimeout(window.chatNotification);
    }
    next();
  },
  methods: {
    incCommentFile(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        var base_self = this;
        reader.onload = (e) => {
          base_self.file_names.push(input.srcElement.files[0].name);
          base_self.files.push(base_self.$refs.updateCommentImgInput.files[0]);
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    devCommentFile(img_name) {
      this.file_names.forEach((item, index) => {
        var item = this.file_names[index];
        if (img_name === item) {
          this.file_names.splice(index, 1);
          this.files.splice(index, 1);
        }
      });
    },
    sendComment() {
      this.$vs.loading();
      let formdata = new FormData();
      formdata.append("model_type", "1");
      formdata.append("model_id", window.SingleRequestApp.$route.params.id);
      formdata.append(
        "comment",
        this.comment.message ? this.comment.message : null
      );
      this.files.forEach((item, index) => {
        formdata.append("files[" + index + "]", item);
      });
      this.$http
        .post("/comments/store", formdata)
        .then((response) => {
          if (response.data.status == true) {
            window.GETCCMT.success(
              "Commentaire enregistré avec succès",
              response
            );
            this.comment.message = "";
            this.files = [];
            this.file_names = [];
          }
          this.$vs.loading.close();
          base_self.general();
        })
        .catch((error) => {
          console.log(error);
          window.GETCCMT.error({
            message: "Echec envoi commentaire a échoué.",
          });
          this.$vs.loading.close();
        });
    },
    putInStandBy() {
      this.$vs.loading();
      this.$http
        .post("/requests/put-in-standby", {
          request_id: window.SingleRequestApp.$route.params.id,
        })
        .then((response) => {
          if (response.data.status == true) {
            window.GETCCMT.success("Ticket suspendu avec succès", response);
          }
          this.$vs.loading.close();
          base_self.general();
        })
        .catch((error) => {
          console.log(error);
          window.GETCCMT.error({
            message: "La suspension du ticket a échoué.",
          });
          this.$vs.loading.close();
        });
    },
    cancelRequest() {
      if (confirm("Etes-vous sûr de vouloir annuler ce ticket ?")) {
        this.$vs.loading();
        this.$http
          .post("/requests/cancel-request", {
            request_id: window.SingleRequestApp.$route.params.id,
          })
          .then((response) => {
            if (response.data.status == true) {
              window.GETCCMT.success("Ticket annulé avec succès", response);
            }
            this.$vs.loading.close();
            base_self.general();
          })
          .catch((error) => {
            console.log(error);
            window.GETCCMT.error({
              message: "Annulation du ticket a échouée.",
            });
            this.$vs.loading.close();
          });
      }
    },
    stopStandBy() {
      this.$vs.loading();
      this.$http
        .post("/requests/stop-standby", {
          request_id: window.SingleRequestApp.$route.params.id,
        })
        .then((response) => {
          if (response.data.status == true) {
            window.GETCCMT.success(
              "Reprise du traitement effectuée avec succès",
              response
            );
          }
          this.$vs.loading.close();
          base_self.general();
        })
        .catch((error) => {
          console.log(error);
          window.GETCCMT.error({
            message: "Impossible de reprendre le traitement du ticket.",
          });
          this.$vs.loading.close();
        });
    },
    showSendModal() {
      if (this.information.type_id == "1") {
        this.info = Object.assign({
          title: this.information.title,
          email: this.information.customer.email,
          phone: this.information.customer.phone,
          copy: this.information.copy,
          message: "",
          img_names: [],
          img: [],
          files: [],
        });
        this.closePrompt = true;
      } else {
        if (confirm("Souhaitez-vous vraiment clôturer ce ticket ?")) {
          this.end_request({});
        }
      }
    },
    toggleDataPrompt(val = false) {
      this.addNewPrompt = val;
    },
    toggleClosePrompt(val = false) {
      this.closePrompt = val;
    },
    toggleFolderPrompt(val = false) {
      this.showFolder = val;
    },
    getCharger() {
      this.$vs.loading();
      this.$http
        .get("/users?profile=3&paginate=0")
        .then((response) => {
          this.charger = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    assign() {},
    assignShow() {
      this.getCharger();
      this.addNewPrompt = true;
    },
    changeRequestState() {
      if (this.appreciation != 4 && this.appreciation != 9) {
        this.raison = "";
        this.error = [];
      }
    },
    checkReOpenCustomer() {
      let index = Number(base_self.information.status_index);
      if (index === 4 || index === 8 || index === 9) {
        return true;
      }
      return false;
    },
    addToFolder() {
      this.showFolder = true;
      this.$vs.loading();
      this.$http
        .get("/folders?paginate=1")
        .then((response) => {
          this.folders = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    openinnewwindows(url) {
      window.open(url, "_blank");
    },
    downloadFile(name, url) {
      this.$vs.loading();
      this.$http({
        url: "/messages/file",
        method: "POST",
        responseType: "blob",
        data: {
          name: name,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
    verifyUser(user) {
      if (user === base_self.user_id) {
        return true;
      }
      return false;
    },
    async start_request() {
      base_self.$vs.loading();
      let response = await base_self.$store.state.requests_begin_treat({
        id: window.SingleRequestApp.$route.params.id,
      });
      if (response.data.status) {
        window.GETCCMT.success(
          "La demande est démarrée avec succès.",
          response
        );
      } else {
        window.GETCCMT.error({
          message: "Le démarrage de la demande a échouée.",
        });
      }
      base_self.general();
      base_self.$vs.loading.close();
    },
    async requests_reopen() {
      base_self.$vs.loading();
      let response = await base_self.$store.state.requests_reopen({
        id: window.SingleRequestApp.$route.params.id,
      });
      if (response.data.status) {
        window.GETCCMT.success(
          "La demande est réouverte avec succès.",
          response
        );
        base_self.$router.push("/requests");
      } else {
        window.GETCCMT.error({
          message: "La réouverture de la demande a échouée.",
        });
      }
      base_self.$vs.loading.close();
    },
    async satisfied_request() {
      base_self.$vs.loading();
      window.GETCCMT.$http
        .post("/requests/close", {
          id: window.SingleRequestApp.$route.params.id,
          satisfied: base_self.appreciation,
          raison: base_self.raison,
        })
        .then((response) => {
          base_self.$vs.loading.close();
          if (response.data.status) {
            this.error = [];
            window.GETCCMT.success(
              "La demande est clôturée avec succès.",
              response
            );
            base_self.$router.push("/requests");
          } else {
            window.GETCCMT.error({
              message: "La clôture de la demande a échouée.",
            });
          }
        })
        .catch((error) => {
          base_self.$vs.loading.close();
          if (error.response.status === 401) {
            window.GETCCMT.$router.push("/login");
          } else {
            base_self.error = error.response.data.errors;
          }
        });
    },
    async no_satisfied_request() {
      let response = await base_self.$store.state.requests_close({
        id: window.SingleRequestApp.$route.params.id,
        satisfied: false,
      });
      if (response.data.status) {
        window.GETCCMT.success(
          "La demande est clôturée avec succès.",
          response
        );
        base_self.$router.push("/requests");
      } else {
        window.GETCCMT.error({
          message: "La clôture de la demande a échouée.",
        });
      }
    },
    async end_request(data) {
      base_self.$vs.loading();

      const keys = Object.keys(data);
      var form = new FormData();
      var length = keys ? keys.length : 0;
      keys.forEach((key, index) => {
        var item = key;
        form.append(item, data[item]);
      });

      var length = data.files ? data.files.length : 0;
      for (let i = 0; i < length; i++) {
        var item = data.files[i];
        form.append("files[" + i + "]", item);
      }
      // for (let i = 0; i < length; i++) {
      //   var item = data.copy[i];
      //   form.append("copy[" + i + "]", item);
      // }
      form.append("id", this.information.id);
      // form.append('files', data.files);
      let response = await base_self.$store.state.requests_close(form);
      if (response.data.status) {
        window.GETCCMT.success(
          "La demande est clôturée avec succès.",
          response
        );
      } else {
        window.GETCCMT.error({
          message: "La clôture de la demande a échouée.",
        });
      }
      base_self.general();
      base_self.$vs.loading.close();
    },
    async endRequestNoFeedBack(data) {
      base_self.$vs.loading();
      let response = await base_self.$store.state.requests_close({
        id: this.information.id,
        rca: data.rca,
        solution: data.solution,
      });
      if (response.data.status) {
        window.GETCCMT.success(
          "La demande est clôturée avec succès.",
          response
        );
      } else {
        window.GETCCMT.error({
          message: "La clôture de la demande a échouée.",
        });
      }
      base_self.general();
      base_self.$vs.loading.close();
    },
    getPriorityColor(status) {
      status = status.toLowerCase();
      if (status == "normale") return "primary";
      if (status == "basse") return "success";
      if (status == "haute") return "danger";
      return "primary";
    },
    convert_date(ddate) {
      //console.log(moment(ddate, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYY à HH:mm:ss'))
      return moment(ddate, "YYYY-MM-DD HH:mm:ss").format(
        "DD/MM/YYYY à HH:mm:ss"
      );
      // let date___o = new Date(ddate);
      // let date = ('0' + (date___o).getDate()).slice(-2) + '/' + ('0' + ((date___o).getMonth() + 1)).slice(-2) + '/' + (date___o).getFullYear();
      // let time = (date___o).getHours() + ':' + ('0' + ((date___o).getMinutes() + 1)).slice(-2) + ':' + ('0' + (date___o).getSeconds()).slice(-2);

      // return {date, time, dateTime: date + ' à ' + time};
    },
    closeCardAnimationDemo(card) {
      base_self.messages_request(base_self.$route.params.id);
      card.removeRefreshAnimation(2000);
    },
    closeCardAnimation(card) {
      base_self.general();
      card.removeRefreshAnimation(2000);
    },
    general() {
      //base_self.$vs.loading()
      base_self.getRequests_detail_approbation(base_self.$route.params.id);
      base_self.getRequests_detail_information(base_self.$route.params.id);
      base_self.getRequests_detail_history(base_self.$route.params.id);
      base_self.getRequests_detail_tasks(base_self.$route.params.id);
      base_self.getRequests_detail_comments(base_self.$route.params.id);
      //base_self.$vs.loading.close()
    },
    async messages_create(message) {
      this.$vs.loading();
      this.error = [];
      let response = await base_self.$store.state.messages_create({
        request_id: window.SingleRequestApp.$route.params.id,
        message,
      });
      this.$vs.loading.close();
      // console.log('response: ', response);
      if (!response.data.status) {
        window.GETCCMT.error({ message: "L'envoie du méssage a échouée." });
      } else this.chatMsgInput = "";
    },
    async messages_request(id) {
      let response = await base_self.$store.state.messages_request({}, id);
      base_self.chatLog = response.data;
      //console.log(base_self.chatLog);
    },
    async getRequests_detail_information(id) {
      let response = await base_self.$store.state.requests_detail_information(
        {},
        id
      );

      base_self.information = response.data;
      // console.log(' ------base_self.information: ------------ ', base_self.information);
    },
    async getRequests_detail_history(id) {
      let response = await base_self.$store.state.requests_detail_history(
        {},
        id
      );

      var length = response.data.length;
      var array = [];

      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = response.data[iuoy];

        array.push({
          color: "success",
          icon: "CheckIcon",
          title: item.title,
          desc: item.content,
          time: item.created_at,
        });
      }

      base_self.history = array;
    },
    async getRequests_detail_tasks(id) {
      let response = await base_self.$store.state.requests_detail_tasks({}, id);

      base_self.tasks = response.data;
    },
    async getRequests_detail_comments(id) {
      let response = await base_self.$store.state.requests_detail_comments({
        model_type: "1",
        model_id: id,
      });

      base_self.comments = response.data;
    },
    async getRequests_detail_approbation(id) {
      let response = await base_self.$store.state.requests_detail_approbation(
        {},
        id
      );
      base_self.approvalDatas = response.data;
      if (response.data.length > 0) base_self.test = true;
    },
    sendFile(input) {
      this.$vs.loading();
      this.error = [];
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = async (e) => {
          const form = new FormData();
          form.append("files", base_self.$refs.updateImgInput.files[0]);
          form.append("message", "");
          form.append("request_id", window.SingleRequestApp.$route.params.id);

          this.$http
            .post("/messages/create", form, {
              //responseType: 'blob',
            })
            .then((response) => {
              if (response.data.status) {
                this.chatMsgInput = "";
                this.$vs.loading.close();
              }
            })
            .catch((error) => {
              //console.log(error.response.data)
              this.$vs.loading.close();
              if (error.response.status === 401) {
                this.$vs.notify({
                  title: "Erreur",
                  text: "Votre session a expiré",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
                this.$router.push({ name: "login" });
              } else if (error.response.status === 422) {
                this.error = error.response.data.errors;
                this.chatMsgInput = "";
              }
            });
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    truncateFileName(input) {
      if (input.length > 15) {
        return input.substring(0, 25) + "...";
      }
      return input;
    },
  },
  computed: {
    commentTabTitle() {
      // return this.comment_tab_title  + '(' + this.comments.length +')';
      return this.comment_tab_title;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    makeAccessApprobation() {
      let $el = false;

      switch (base_self.$store.state.AppActiveUser.profile_id) {
        case 3:
          $el = true;
          break;
        case 1:
          $el = true;
          break;
        case 2:
          $el = true;
          break;
        default:
          $el = false;
          break;
      }
      if ($el === true && base_self.$route.params.event == 1) {
        return true;
      }
      return false;
    },
    demarrerLeTraitement() {
      var is_ok = true;

      var approval_length = base_self.approvalDatas.length;
      for (let iuoy = 0; iuoy < approval_length; iuoy++) {
        var item = base_self.approvalDatas[iuoy];

        if (item.status === 0 || item.status === 2) {
          is_ok = false;
          break;
        }
      }
      if (base_self.information.folder) {
        let planned_date = new Date(base_self.information.folder_date);
        let now = new Date();
        if (planned_date <= now) {
          is_ok = true;
        } else is_ok = false;
      }
      return is_ok;
    },
  },
  created() {
    base_self = this;
    window.SingleRequestApp = this;
  },
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;
}
.comment_zone {
  border: 1px solid black;
  border-radius: 5px;
  padding: 10px;
  background: #f8f8f8;
}
.vs-textarea {
  background: #ffffff !important;
}
.scroll-area {
  position: relative;
  margin: auto;
  // width: 400px;
  height: 300px;
}
</style>
